import React from 'react';
import CalendarSelector from "../../components/home/CalendarSelector";
import { ModalCalendar } from "../../components/home/modal/ModalCalendar.modal";
import { ModalConfiguration } from "../../components/home/modal/ModalConfiguration.modal";

export default function HomePage() {
  return (
    <>
      <CalendarSelector />
      <ModalCalendar />
      <ModalConfiguration />
    </>
  );
}
